import { render } from "./PasswordChangeSendMailCompletelyPage.vue?vue&type=template&id=51af8959&scoped=true"
import script from "./PasswordChangeSendMailCompletelyPage.vue?vue&type=script&lang=ts"
export * from "./PasswordChangeSendMailCompletelyPage.vue?vue&type=script&lang=ts"

import "./PasswordChangeSendMailCompletelyPage.vue?vue&type=style&index=0&id=51af8959&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-51af8959"
/* hot reload */
if (module.hot) {
  script.__hmrId = "51af8959"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51af8959', script)) {
    api.reload('51af8959', script)
  }
  
  module.hot.accept("./PasswordChangeSendMailCompletelyPage.vue?vue&type=template&id=51af8959&scoped=true", () => {
    api.rerender('51af8959', render)
  })

}

script.__file = "src/views/passwordChange/PasswordChangeSendMailCompletelyPage.vue"

export default script